module.exports = __webpack_public_path__ + "img/horangit_4.6dcda89d.png";